import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface IBookingReceivedPayload {
  bookingId: string;
}

export class BookingReceivedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingReceivedEvent';

  constructor(public readonly payload: IBookingReceivedPayload) {
  }
}
